<template>
  <div class="gym-card">
    <div class="columns is-gapless mb-0">
      <div class="column is-narrow">
        <div class="background-container" :style="background" @click="viewGym($event)" />
      </div>
      <div class="column">
        <div class="content-wrapper">
          <div class="columns">
            <div class="column">
              <h2 class="title is-3">{{gym.name}}</h2>
              <h2 class="subtitle is-hidden-desktop mb-0">
                <i class="fas fa-map-marker-alt mr-1"></i>
                {{gym.distance | formatRange }} away
              </h2>
              <h2 class="subtitle is-4 is-hidden-touch">
                <i class="fas fa-map-marker-alt mr-1"></i>
                {{gym.distance | formatRange }} away
              </h2>
              <p class="is-hidden-touch">{{gym.address}}</p>
              <h3 class="subtitle is-hidden-desktop">
                <span class="mr-3">
                  <i class="fas fa-dumbbell gym-blue"></i>
                  {{ gym.facilities[0].name }}
                </span>
                <span class="mr-3">
                  <div v-if="gym.review_avg">
                    <i class="fas fa-star"></i>
                      {{ Number.parseFloat(gym.review_avg).toFixed(1) }} ({{
                      parseInt(gym.review_count)
                      }})
                  </div>
                  <div v-else>
                    <p class="is-size-4">No reviews. Be the first!<i class="fas fa-arrow-circle-right rightArrow" @click="goToCreateReview()"></i></p>
                  </div>
                </span>
              </h3>
            </div>
            <div class="column">
              <FacilityList
                class="is-hidden-touch"
                :facilities="gym.facilities"
                @open-gym="viewGymToFacilities"
                :is_gym_card="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gym-footer">
      <RatingBar
        class="is-hidden-touch"
        :rating="parseFloat(gym.review_avg)"
        :reviews_number="parseInt(gym.review_count)"
        :gym_id="gym.gym_id"
      />
      <div class='card-buttons'>
        <button
          class="button search-button slide-left"
          @click="freeFormPass()"
        >Request a free pass</button>
        <button
          class="button search-button slide-left"
          @click="viewGym($event)"
        >More info</button>
        <button
          class="button search-button slide-left"
          @click="openWebsite($event, gym.website_link, gym.gym_id)"
        >Go to Website</button>
      </div>
    </div>
  </div>
</template>

<script>
import FacilityList from "../molecules/FacilityList.vue";
import RatingBar from "../molecules/RatingBar";
import { mapActions } from "vuex";

export default {
  components: {
    FacilityList,
    RatingBar
  },
  props: {
    gym: Object
  },
  data() {
    return {
      reviews: [],
      active: false
    };
  },
  methods: {
    ...mapActions(["addReferral"]),
    openWebsite(event, website, gymId) {
      event.target.blur();
      if (website.indexOf("http") === -1) {
        website = "http://" + website;
      }
      window.open(
        website,
        "_blank" // <- This is what makes it open in a new window.
      );
      this.addReferral(gymId);
    },
    openReviewModal() {
      this.active = true;
    },
    freeFormPass() {
      let selected_gym = {
        gym_id: this.gym.gym_id,
        gym_name: this.gym.name
      }
      this.$store.commit('selectFreePassGym', selected_gym);
      this.$store.commit('freeFormPassSwitch');
    },
    viewGym(event) {
      if (event) {
        event.target.blur();
      }
      this.$store.commit("storeGym", this.gym);
      this.$router.push(`/gym/${this.gym.gym_id}`);
    },
    viewGymToFacilities() {
      this.$store.commit("storeGym", this.gym);
      this.$router.push(`/gym/${this.gym.gym_id}/#facilities`);
    },
    goToCreateReview(){
      if(this.$route.name !== "gym"){
        this.$router.push(`/gym/${this.gym.gym_id}/#create-review-button`);
      } else {
        this.$emit('scrollToCreate');
      }
    }
  },
  async mounted() {
    for (let [value] of Object.entries(this.gym.opening_times)) {
      if (value.length == 0) {
        value.push("Closed");
      }
    }

    try {
      const response = await this.$http.get(`/api/reviews/gym/${this.gym.id}`);
      this.reviews = response.data;
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    averageRating() {
      let runningTotal = 0;
      this.reviews.forEach(review => {
        runningTotal += review.rating;
      });
      return runningTotal / this.reviews.length;
    },
    background() {
      return `background-image : url(${JSON.parse(this.gym.images)[0]})`;
    }
  }
};
</script>

<style scoped>
.background-container {
  height: 100%;
  width: 400px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

.button {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.card-buttons {
  display: flex;
  flex-wrap: wrap;
}

.content-wrapper {
  padding: 1rem;
}

.gym-card {
  background-color: #fff;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  color: #4a4a4a;
  display: block;
}

.gymCardImage {
  height: 204px;
  width: 363px;
}

.gym-footer {
  background: #333;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

p {
  font-size: 1.5rem;
}

.rightArrow {
  color: #00c5fd; 
  cursor: pointer;
}

.w-100 {
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .background-container {
    height: 175px !important;
    width: auto !important;
  }
  .card-buttons {
    width: 100%;
  }
  .search-button {
    width: 100%;
    margin: 0.5rem 0;
  }
}
</style>